import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import Helper from "../plugins/Helper/Helper"
import i18n from '@/plugins/vue-i18n';
export class ExportMarketSetting {
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportMarketAreaAccountingProduct(areas, accountingProducts, areaAccountingProducts) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    let hashAreaAccByArea = {}
    let columns = [
      {
        header: i18n.t('area.stall_name_or_number'),
        key: "areaName",
        width: 20,
        style: {
          alignment: {
            vertical: 'middle', horizontal: 'center'
          }
        }
      },
      {
        header: i18n.t('area.size_of_stall'),
        key: "size",
        width: 20,
        style: {
          alignment: {
            vertical: 'middle', horizontal: 'rigth'
          }
        }
      },
      {
        header: i18n.t('area.shop_name'),
        key: "businessName",
        width: 20,
        style: {
          alignment: {
            vertical: 'middle', horizontal: 'center'
          }
        }
      },
      {
        header: i18n.t('bill.customer_market_id'),
        key: "customerMarketId",
        width: 20,
        style: {
          alignment: {
            vertical: 'middle', horizontal: 'center'
          }
        }
      },
      {
        header: i18n.t('contract.fullname_of_contractor'),
        key: "contractName",
        width: 20,
        style: {
          alignment: {
            vertical: 'middle', horizontal: 'left'
          }
        }
      }
    ]

    if (accountingProducts && accountingProducts.length) {
      for (let accountingProduct of accountingProducts) {
        if (accountingProduct.type != "facility") {
          columns.push({
            header: accountingProduct.name,
            key: accountingProduct.objectId,
            width: 15,
            style: {
              alignment: {
                vertical: 'middle', horizontal: 'rigth'
              }
            }
          })
        }
      }
    }

    if (areaAccountingProducts && areaAccountingProducts.length) {
      for (let areaAccountingProduct of areaAccountingProducts) {
        let area = areaAccountingProduct.area
        if (!hashAreaAccByArea[area.objectId]) hashAreaAccByArea[area.objectId] = []
        hashAreaAccByArea[area.objectId].push(areaAccountingProduct)
      }
    }

    worksheet.columns = columns

    if (areas && areas.length) {
      for (let area of areas) {
        let obj = {
          areaName: area.name,
          size: area.size || '-',
          businessName: area.businessName || '-',
          customerMarketId: area.contract ? area.contract.customerMarketId : '-',
          contractName: area.contractName || '-',
        }
        if (area.size) {
          area.size = parseFloat(area.size);
          obj.size = Helper.toCurrency(obj.size)
          // obj.size.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          obj.size = '0.00';
        }

        if (hashAreaAccByArea[area.objectId] && hashAreaAccByArea[area.objectId].length) {
          for (let areaAccountingProduct of hashAreaAccByArea[area.objectId]) {
            let accountingProduct = areaAccountingProduct.accountingProduct
            if(accountingProduct.type == "discount"){
              obj[accountingProduct.objectId] = areaAccountingProduct.originalDiscount * -1 || ""
            }else{
              obj[accountingProduct.objectId] = areaAccountingProduct.cost || ""
            }
            
          }
        }
        worksheet.addRow(obj)
      }
    }

    return this.saveFile(workbook, `market-area-acccounting-product-${moment(new Date()).format("DDMMYYYY")}`);
  }

}